var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9FC8D60F-3FB3-4447-9239-CE3373640CAC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,19 C5.037,19 1,14.963 1,10 C1,9.044 1.153,8.124 1.43,7.259 L4.241,8.333 C4.087,8.863 4,9.421 4,10 C4,13.308 6.692,16 10,16 C13.308,16 16,13.308 16,10 C16,6.86 13.575,4.281 10.5,4.025 L10.5,1.025 C15.23,1.287 19,5.206 19,10 C19,14.963 14.963,19 10,19 M7.548,1.348 L8.204,4.275 C6.616,4.775 5.316,5.921 4.601,7.4 L1.792,6.327 C2.872,3.922 4.976,2.078 7.548,1.348 M9.18,4.063 L8.524,1.132 C8.844,1.079 9.17,1.044 9.5,1.025 L9.5,4.025 C9.392,4.034 9.286,4.048 9.18,4.063 M10,5 C12.761,5 15,7.239 15,10 C15,12.761 12.761,15 10,15 C7.239,15 5,12.761 5,10 C5,7.239 7.239,5 10,5 M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/PieChart.c742284edfbb71088270352001f5449a.svg";
export { ForwardRef as ReactComponent };